import { Badge } from '@/components/ui/badge';
import { toolState as toolStateOptions } from '@/features/traceability/data/toolState';
import { useTranslation } from '@/hooks/useTranslation';
import { toolStateTone } from '@/lib/toolStateTone';

export type ToolStateBadgeProps = {
  toolState: string | null | undefined;
  /** Shown when the state is missing (default: "Non renseigné"). */
  fallback?: string;
  size?: 'sm' | 'md';
  className?: string;
};

/** A tool state (Neuf / Usé / Cassé / Inconnu) as a badge, same colours on every screen. */
export function ToolStateBadge({ toolState, fallback, size, className }: ToolStateBadgeProps) {
  const { t } = useTranslation();
  if (!toolState) {
    return <span className="text-muted-foreground">{fallback ?? t('common.notProvided')}</span>;
  }
  const option = toolStateOptions.find((s) => s.value === toolState);
  return (
    <Badge tone={toolStateTone(toolState)} dot size={size} className={className}>
      {option?.labelKey ? t(option.labelKey) : toolState}
    </Badge>
  );
}
